import { render, staticRenderFns } from "./AddStudentUpdateAlbumDialog.vue?vue&type=template&id=6fdcec6a&scoped=true"
import script from "./AddStudentUpdateAlbumDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentUpdateAlbumDialog.vue?vue&type=script&lang=js"
import style0 from "./AddStudentUpdateAlbumDialog.vue?vue&type=style&index=0&id=6fdcec6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcec6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fdcec6a')) {
      api.createRecord('6fdcec6a', component.options)
    } else {
      api.reload('6fdcec6a', component.options)
    }
    module.hot.accept("./AddStudentUpdateAlbumDialog.vue?vue&type=template&id=6fdcec6a&scoped=true", function () {
      api.rerender('6fdcec6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/album/AddStudentUpdateAlbumDialog.vue"
export default component.exports